import moment from 'moment';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { ELSFlex } from '@els/els-ui-common-react';
import { DATE_FORMAT, DATE_FORMAT_ANZ, Locales } from 'constants/app.constant';
import { appSelectors } from 'redux/ducks/app';
import SNGTimePicker from './SNGTimePicker';
import TimeZoneView from './TimeZoneView';
import SNGDate from '../date/SNGDate';

interface DateTimeViewProps {
  id: string;
  name?: string;
  value: string;
  changeHandler: (event: React.SyntheticEvent | null, value: string) => void;
  disableBefore?: Date;
  disableAfter?: Date;
  isDisabled?: boolean;
  showTimeZone?: boolean;
  locale?: Locales;
}

class DateTimeView extends PureComponent<DateTimeViewProps> {
  static displayName = 'DateTimeView';

  getDateFormat = () => {
    const { locale } = this.props;
    return locale === Locales.EN_US ? DATE_FORMAT : DATE_FORMAT_ANZ;
  };

  parseValue = () => {
    const { value } = this.props;
    const dateFormat = this.getDateFormat();
    const m = value ? moment(value) : moment();

    return {
      dateValue: m.isValid() ? m.format(dateFormat) : '',
      hour: m.isValid() ? m.format('hh') : '01',
      minute: m.isValid() ? m.format('mm') : '00',
      period: m.isValid() ? (m.format('a') as 'am' | 'pm') : 'am'
    };
  };

  emitCombinedValue = ({ dateValue, hour, minute, period }: { dateValue: string; hour: string; minute: string; period: 'am' | 'pm' }) => {
    const dateFormat = this.getDateFormat();
    const combined = moment(`${dateValue} ${hour}:${minute} ${period}`, `${dateFormat} hh:mm a`, true);

    this.props.changeHandler(null, combined.isValid() ? combined.toISOString() : '');
  };

  handleDateChange = (dateValue: string) => {
    const current = this.parseValue();

    this.emitCombinedValue({
      dateValue,
      hour: current.hour,
      minute: current.minute,
      period: current.period
    });
  };

  handleTimeChange = ({ hour, minute, period }: { hour: string; minute: string; period: 'am' | 'pm' }) => {
    const current = this.parseValue();

    this.emitCombinedValue({
      dateValue: current.dateValue,
      hour,
      minute,
      period
    });
  };

  render() {
    const { id, disableBefore, disableAfter, isDisabled, showTimeZone } = this.props;
    const { dateValue, hour, minute, period } = this.parseValue();

    return (
      <ELSFlex left middle className="u-els-padding-1o2">
        <SNGDate id={id} value={dateValue} onDateChange={this.handleDateChange} disableBefore={disableBefore} disableAfter={disableAfter} isDisabled={isDisabled} />
        <SNGTimePicker id={id} hour={hour} minute={minute} period={period} onChange={this.handleTimeChange} isDisabled={isDisabled} />

        {showTimeZone && (
          <span className="date-time-view__timezone">
            <TimeZoneView timeZone={Intl.DateTimeFormat().resolvedOptions().timeZone} timeZoneType="abbr" />
          </span>
        )}
      </ELSFlex>
    );
  }
}

const mapStateToProps = (state) => ({
  locale: appSelectors.getLocale(state)
});

export default connect(mapStateToProps)(DateTimeView);
